<template lang="pug">
textbox-base.textbox-search(v-model='inputValue', :placeholder='placeholder')
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import TextboxBase from '@/components/atoms/TextboxBase.vue'

/**
 * 検索用テキストボックス
 */
@Component({
  components: {
    TextboxBase,
  },
})
export default class TextboxSearch extends Vue {
  // 入力値
  @Prop()
  value!: string

  // プレースホルダー（任意）
  @Prop()
  placeholder?: string

  // 入力値ゲッター・セッター
  get inputValue(): string {
    return this.value
  }
  set inputValue(value: string) {
    this.$emit('input', value)
  }
}
</script>

<style lang="stylus" scoped>
.textbox-search
  width 170px
  height 36px
  padding 5px 20px
  border-radius 48px
  background-color var(--color-input-manager-search-textbox__background)
  border 1px solid var(--color-input-manager-search-textbox__border)
  transition-property background-color
  transition-timing-function ease-out
  transition-duration 300ms

  &:hover, &:focus
    border-width 2px
    padding 4px 19px
    background-color transparent
</style>
